module.exports = __webpack_public_path__ + "static/media/1443603140_resized.d483a5ef.jpg";